// extracted by mini-css-extract-plugin
export default {"espacamento":"Texto_espacamento__56YVk","label":"Texto_label__W1p-y"};